export default [
  'assetAccountsNotesReceivable',
  'assetCashValueLifeInsurance',
  'assetIraOrOtherRetirement',
  'assetNotesReceivable',
  'assetOtherAutos',
  'assetOtherPersonalProperty',
  'assetRealEstateHomestead',
  'assetsMisc',
  'assetOthers',
  'currentCashOnHandInBank',
  'estimatedCreditScore',
  'liabilityAccountsNotesPayableBusiness',
  'liabilityAccountsNotesPayableOther',
  'liabilityCreditCardDebt',
  'liabilityInstallmentAuto',
  'liabilityInstallmentOther',
  'liabilityOther',
  'liabilityRealEstateMortgageHomestead',
  'liabilityRealEstateMortgageInvestments',
  'liabilityUnpaidTaxes',
  'liabilityLifeInsuranceLoan',
  'valueInvestmentPortfolio',
  'valueRealEstateOwned',
  'totalAssets',
  'totalLiabilities',
];



// WEBPACK FOOTER //
// ./src/vuex/modules/profile/resources/finances/financesKeys.js